import { APIPromise } from "../services/HttpService";
import { ApiDefinition } from "./ApiDefinition";
import {
  CreateDashboardRequest,
  Dashboard,
  DashboardEditStatus,
  DashboardHistoryDto,
  DashboardPaginatedRequest,
  DashboardSimpleDto,
  PaginatedResponse,
} from "./model/dashboard/Dashboard";

class DashboardApiDefinition extends ApiDefinition {
  constructor() {
    super("/dashboard");
  }

  async getDashboards(companyRef: string): APIPromise<Array<DashboardSimpleDto>> {
    return this.get(`managed/${companyRef}`);
  }

  async getAllDashboards(): APIPromise<Array<Dashboard>> {
    return this.get("infos");
  }

  async getDashboard(dashboardId: number): APIPromise<Dashboard> {
    return this.get(`${dashboardId}`);
  }

  async getDashboardHistory(
    request: DashboardPaginatedRequest
  ): APIPromise<PaginatedResponse<DashboardHistoryDto>> {
    return this.get(`${request.dashboardId}/history`, {
      params: { skip: request.skip, take: request.take },
    });
  }

  async getDashboardsInfos(dashboardsId: Array<number>): APIPromise<Array<Dashboard>> {
    return this.get(`infos`, { params: { id: dashboardsId } });
  }

  async createDashboard(dashboard: CreateDashboardRequest): APIPromise<DashboardSimpleDto> {
    return this.post(null, dashboard);
  }

  async updateDashboard(dashboard: Dashboard, allowOverwrite?: boolean): APIPromise<Dashboard> {
    return this.put(dashboard.id.toString(), dashboard, { params: { allowOverwrite } });
  }

  async updateManagedDashboard(dashboard: DashboardSimpleDto): APIPromise<DashboardSimpleDto> {
    return this.put(`managed/${dashboard.id}`, dashboard);
  }

  async deleteDashboard(dashboardId: number): APIPromise<DashboardSimpleDto> {
    return this.delete(`${dashboardId}`);
  }

  async getDashboardEditStatus(
    dashboardId: number,
    version: string,
    firstLoad: boolean
  ): APIPromise<DashboardEditStatus> {
    return this.get(`${dashboardId}/${version}/dashboard-status`, {
      params: { firstLoad: firstLoad || undefined },
    });
  }
}

const DashboardApi = new DashboardApiDefinition();

export default DashboardApi;
